import React, { useState } from "react";
import { FaComments, FaTimes } from "react-icons/fa";

const ChatBotPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChatBot = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Chatbot Button */}
      {!isOpen && (
        <button
          onClick={toggleChatBot}
          className="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-4 rounded-full shadow-xl hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-110"
        >
          <FaComments size={28} />
        </button>
      )}

      {/* Chatbot Popup */}
      {isOpen && (
        <div className="bg-white w-80 h-96 rounded-lg shadow-lg flex flex-col">
          {/* Header */}
          <div className="bg-blue-600 text-white p-4 flex justify-between items-center rounded-t-lg">
            <h3 className="text-lg font-semibold">Chat with Us</h3>
            <button onClick={toggleChatBot}>
              <FaTimes size={20} />
            </button>
          </div>

          {/* Chat Content */}
          <div className="flex-1 p-4 overflow-y-auto">
            <p className="text-gray-600">Hi! Chat is coming soon. In the meantime, you can reach us on WhatsApp!</p>
            {/* Add chatbot messages or integration here */}
          </div>

          {/* Input Area */}
          <div className="p-4 border-t">
            <input
              type="text"
              placeholder="Type your message..."
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          {/* WhatsApp Button */}
          <div className="p-4 border-t">
            <a
              href="https://wa.me/447762160201"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white w-full flex justify-center items-center p-3 rounded-lg shadow-lg hover:bg-green-600 transition-all duration-300"
            >
              Chat on WhatsApp
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBotPopup;